import { createApi } from "@reduxjs/toolkit/query/react";
import { rtkBaseQuery } from "../baseQuery";

export const userApi = createApi({
    baseQuery: rtkBaseQuery,
    reducerPath: "userApi",
    tagTypes: ["USER", "NEW_CHAT"],
    endpoints: (builder) => ({
        getRooms: builder.query({
            query: (data) => {
                return {
                    url: "/chatroom/list/",
                    method: "GET",
                };
            },
            providesTags: ["NEW_CHAT"]
        }),
        getChatHistory: builder.query({
            query: ({ roomId }) => {
                return {
                    url: `/chatroom/history/${roomId}/`,
                    method: "GET",
                };

            },
            transformResponse: (response) => {
                const roomArr = []
                if (response?.length > 0) {
                    response?.map((data) => { 
                        roomArr.push({ sender: "user", text: data?.user_question, id: data?.id })
                        roomArr.push({ sender: "bot", text: data?.bot_answer, id: data?.id })
                        return data
                    })
                }

                return roomArr
            }
        }),
        createRoomChat: builder.mutation({
            query: ({ user_question, roomId, database_id }) => {

                return {
                    url: `/chatroom/send/${roomId}/`,
                    method: "POST",
                    body: { user_question, database_id },

                };

            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        createNewRoomChat: builder.mutation({
            query: (data) => {

                return {
                    url: `/chatroom/send/`,
                    method: "POST",
                    body: data,

                };

            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        fetchAnswerFromDB: builder.mutation({
            query: ({ query, database_id }) => {
                let apiUrl = "/chroma_db/";  
                if (database_id === "Database 2") {
                apiUrl = "/query/";  
                }
                else if (database_id === "Database 3") {
                    apiUrl = "/using-oracle/";
                }
                else{
                    apiUrl = "/chroma_db/";
                }

                return {
                    url: apiUrl,
                    method: "POST",
                    body: { query, database_id },
                };
            },
            invalidatesTags: ["NEW_CHAT"]
        }),
        updateChatFeedback: builder.mutation({
            query: ({ conversation_id, feedback }) => ({
                url: `/chat/${conversation_id}/feedback/`,
                method: 'POST',
                body: feedback,
            }),
    }),
    createEmptyRoom: builder.mutation({
        query: () => ({
            url: "/create_chat/",
            method: "POST",
            }),
    }),
    updateChatName: builder.mutation({
        query: ({ uuid_field, chat_room_name}) => ({
            url: `/chatroom/edit/${uuid_field}/`,
            method: "POST",
            body: {chat_room_name},
        }),
    }),
    deleteChatRoom: builder.mutation({
        query: (uuid_field) => ({
            url: `/chatroom/delete/${uuid_field}/`,
            method: "DELETE",
        }),
    })
    }),
});

export const {
    useGetRoomsQuery,
    useGetChatHistoryQuery,
    useCreateRoomChatMutation,
    useCreateNewRoomChatMutation,
    useFetchAnswerFromDBMutation,
    useUpdateChatFeedbackMutation,
    useCreateEmptyRoomMutation,
    useUpdateChatNameMutation,
    useDeleteChatRoomMutation,

} = userApi;


